<div class="quill-main-wrapper" [formGroup]="group" style="position: relative;">
  <quill-editor class="dataplaceholder" #editor [style]="editorStyleObject"
                [formControl]="control"
                [placeholder]="info?.description_story?.placeholder"
    [minLength]="50" (onEditorCreated)="setFocus($event)">

    <div class="et-toolbar" quill-editor-toolbar>
      <div [hidden]="options" [@optionState]="state">
        <span class="ql-formats">
          <button class="ql-bold" [title]="'Bold'"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-italic" [title]="'Italic'"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered" [title]="'List'"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="bullet" [title]="'List'"></button>
        </span>
        <div class="pull-right">
          <span class="ql-formats">
            <button class="ql-image" [title]="'Image'"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-link" [title]="'Link'"></button>
          </span>
          <span style="margin: auto" class="ql-formats" >
            <button mat-icon-button type="button" class="option-button" (click)="toggleOptions()">
              <mat-icon class="options" matSuffix>more_vert</mat-icon>
            </button>
          </span>
        </div>
      </div>
      <div [hidden]="!options" [@optionState]="state">
        <span class="ql-formats">
          <button class="ql-blockquote" [title]="'Blockquote'"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-code-block" [title]="'Code-Block'"></button>
        </span>
        <span class="pull-right">
          <span class="ql-formats">
            <button mat-icon-button type="button" class="option-button" (click)="history('undo')">
              <mat-icon class="options" matSuffix>undo</mat-icon>
            </button>
            <button mat-icon-button type="button" class="option-button" (click)="history('redo')">
              <mat-icon class="options" matSuffix>redo</mat-icon>
            </button>
          </span>
          <div style="margin: auto" class="ql-formats">
            <button mat-icon-button type="button" class="option-button" (click)="toggleOptions()">
              <mat-icon class="options" matSuffix>close</mat-icon>
            </button>
          </div>
        </span>
      </div>
    </div>
  </quill-editor>
  <mat-spinner *ngIf="imageUploading" [diameter]="50"></mat-spinner>

  <div class="errors">
    <small class="error-message" *ngIf="control?.hasError('required') && control?.touched">{{info?.fieldRequired}}</small>
    <small class="error-message" *ngIf="control?.hasError('minlength') && control?.touched">please enter more details!!</small>
  </div>
</div>
<div class="description-help-text">
  <div class="popover-direction-arrow"></div>
  <div class="popover-container">
    <div class="p-title mb-4">{{ info?.description_story?.popover?.desc }}</div>
    <div class="p-desc" [innerHTML]="info?.description_story?.popover?.placeholder">
      <!-- <div>• Write a story that does justice to your cause and makes the supporter click the donate button.</div>
      <div>• Don’t get overwhelmed if you feel stuck.</div>
      <div>• Follow these steps:</div>
      <div>• Talk about who you're raising funds for, be it yourself or your loved one.</div>
      <div>• Explain why you're raising funds.</div>
      <div>• Make an appeal to your supporters.</div>
      <div>• Let your supporters know what made you start a fundraiser for this cause so they feel motivated to make a contribution.</div>
      <div>• Provide all details so your supporters know where their money is going.</div>
      <div>• Avoid pasting information directly from a Word document.</div> -->

    </div>
  </div>
<div>
